import { useEffect, useRef, useState } from "react";
import { List } from "../../ui/List";
import { Stippet } from "../../ui/Stippet";
import { StippetCreator } from "./StippetCreator";
import styles from "./StippetsArea.module.css";
import sectionStyles from "../../styles/Section.module.css";

export function StippetsArea({
  stippets,
  onCreateStippet,
  currentWorld,
  currentWorldName,
  onDeleteWorld,
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!isMenuOpen) return;
    const handleClickOutside = (event) => {
      if (!menuRef.current || menuRef.current.contains(event.target)) return;
      setIsMenuOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMenuOpen]);

  return (
    <section className={styles.stippetArea}>
      <div
        className={`${sectionStyles.sectionHeader} ${sectionStyles.sectionHeaderTight}`}
      >
        <div>
          <p className={sectionStyles.sectionKicker}>Selected world</p>
          <h2
            className={`${sectionStyles.sectionTitle} ${styles.selectedWorldName}`}
          >
            {currentWorldName}
          </h2>
        </div>
        <div
          className={`${styles.menuWrap} ${styles.menuWrapAnchor}`}
          ref={menuRef}
        >
          <button
            className={styles.menuButton}
            type="button"
            aria-label="World options"
            aria-haspopup="menu"
            aria-expanded={isMenuOpen}
            onClick={() => setIsMenuOpen((prev) => !prev)}
          >
            ⋯
          </button>
          {isMenuOpen && (
            <div className={styles.menu} role="menu">
              <button
                className={styles.menuItem}
                type="button"
                role="menuitem"
                onClick={() => {
                  setIsMenuOpen(false);
                  setIsConfirmOpen(true);
                }}
              >
                Delete world
              </button>
            </div>
          )}
          {isConfirmOpen && (
            <div className={styles.confirm}>
              <p>Delete this world and all stippets?</p>
              <div className={styles.confirmActions}>
                <button
                  className={styles.confirmCancel}
                  type="button"
                  onClick={() => setIsConfirmOpen(false)}
                >
                  No
                </button>
                <button
                  className={styles.confirmDelete}
                  type="button"
                  onClick={() => {
                    onDeleteWorld(currentWorld);
                    setIsConfirmOpen(false);
                  }}
                >
                  Yes, delete
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <StippetCreator
        onNewStippet={onCreateStippet}
        currentWorld={currentWorld}
      />
      {stippets.length > 0 ? (
        <List className={styles.stippetsList}>
          {stippets.map((stippet) => (
            <Stippet
              title={stippet.title}
              body={stippet.body}
              key={stippet.id}
            />
          ))}
        </List>
      ) : (
        <div className={sectionStyles.emptyState}>
          <p className={sectionStyles.emptyTitle}>No stippets yet</p>
          <p className={sectionStyles.emptyBody}>
            Start with a short title and a few lines of story.
          </p>
        </div>
      )}
    </section>
  );
}
